// extracted by mini-css-extract-plugin
module.exports = {"title":"CustomerDashboard_title__36vDZ","row":"CustomerDashboard_row__2X4ww"};